import defaultImg from '../../../../assets/image/newShop/defaultImg.png';
import {ISummeryBrand} from '../../../../services/hookService/getListBrandSummery/types';

interface IProps {
  data: ISummeryBrand;
  textColor?: string;
  onClick?: () => void;
}

const BrandItem = ({data, textColor, onClick}: IProps) => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-1 w-[4.5rem] flex-shrink-0"
      onClick={onClick}
    >
      <img
        src={data?.logo ?? defaultImg}
        alt={data?.name}
        className="object-fill bg-white border-2 rounded-full min-w-14 w-14 h-14 border-farm-shop-400"
      />
      <span
        className={`line-clamp-1 text-center text-wrap mx-auto ${
          textColor ?? 'text-white'
        } text-sm font-medium`}
      >
        {data?.name}
      </span>
    </div>
  );
};

export default BrandItem;
